export interface StateInfo {
  code: string;
  name: string;
}

export const US_STATES: StateInfo[] = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
  { code: 'AS', name: 'American Samoa' },
  { code: 'GU', name: 'Guam' },
  { code: 'MP', name: 'Northern Mariana Islands' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'VI', name: 'U.S. Virgin Islands' },
];

export interface ProtocolCategory {
  slug: string;
  name: string;
  icon: string;
  sortOrder: number;
}

/** `icon` names map to lucide-react icons in the web app. */
export const PROTOCOL_CATEGORIES: ProtocolCategory[] = [
  { slug: 'universal', name: 'Universal Care', icon: 'ClipboardList', sortOrder: 10 },
  { slug: 'cardiac', name: 'Cardiac', icon: 'HeartPulse', sortOrder: 20 },
  { slug: 'respiratory', name: 'Respiratory', icon: 'Wind', sortOrder: 30 },
  { slug: 'airway', name: 'Airway', icon: 'Stethoscope', sortOrder: 40 },
  { slug: 'medical', name: 'Medical', icon: 'Activity', sortOrder: 50 },
  { slug: 'neuro', name: 'Neurological', icon: 'Brain', sortOrder: 60 },
  { slug: 'trauma', name: 'Trauma', icon: 'Bandage', sortOrder: 70 },
  { slug: 'environmental', name: 'Environmental', icon: 'ThermometerSun', sortOrder: 80 },
  { slug: 'toxicology', name: 'Toxicology', icon: 'FlaskConical', sortOrder: 90 },
  { slug: 'obstetric', name: 'Obstetrics', icon: 'Baby', sortOrder: 100 },
  { slug: 'pediatric', name: 'Pediatrics', icon: 'Smile', sortOrder: 110 },
  { slug: 'behavioral', name: 'Behavioral', icon: 'MessageCircleHeart', sortOrder: 120 },
  { slug: 'operations', name: 'Operations & Policy', icon: 'Siren', sortOrder: 130 },
];
